'use strict';

var toggleTab = function toggleTab(tabId) {
    var isActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var navItems = document.querySelectorAll('[data-product-tabs] [data-nav-item]');
    var tabItems = document.querySelectorAll('[data-product-tabs] [data-tab-item]');

    navItems.forEach(function (navItem) {
        return navItem.classList.toggle('active', isActive && tabId === navItem.getAttribute('data-nav-item'));
    });

    tabItems.forEach(function (tabItem) {
        return tabItem.classList.toggle('active', isActive && tabId === tabItem.getAttribute('data-tab-item'));
    });
};

var initProductTabs = function initProductTabs() {
    var tabsEl = document.querySelector('[data-product-tabs]');
    if (!tabsEl) return;

    tabsEl.querySelectorAll('[data-nav-item]').forEach(function (navItem) {
        navItem.addEventListener('click', function () {
            toggleTab(navItem.getAttribute('data-nav-item'));
        });
    });

    tabsEl.querySelectorAll('[data-tab-item]').forEach(function (tabItem) {
        var mobileHeader = tabItem.querySelector('[data-tab-item-header]');
        if (!mobileHeader) return;

        mobileHeader.addEventListener('click', function () {
            toggleTab(tabItem.getAttribute('data-tab-item'), !tabItem.classList.contains('active'));
        });
    });
};

document.addEventListener('DOMContentLoaded', function () {
    initProductTabs();
});

document.addEventListener('shopify:section:load', function () {
    initProductTabs();
});